// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__39thP","validationTips":"StatementDescriptor_validationTips__f4IPr"};